import { ao as E, a as f, ap as T, m, u as U, o as q, b as O, c as h, e as D, g as c, z as x, ay as M, i as A, t as R, k as _, n as z, an as G } from "./define-element-XpjsV6s1.js";
import { i as d, e as K } from "./utils-CMsllPx8.js";
import { _ as L } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const P = ["aria-labelledby"], j = ["id"], H = ["aria-invalid", "aria-describedby"], J = ["aria-invalid", "aria-describedby"], Q = ["aria-invalid", "aria-describedby"], W = ["id"], X = ["id"], Z = {
  __name: "DateOfBirth",
  props: /* @__PURE__ */ G({
    format: {
      type: String,
      default: "MM-DD-YYYY"
    },
    minAge: {
      type: Number,
      default: 0
    },
    invalid: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(g, { expose: C }) {
    const y = g, o = "date-of-birth-" + Math.random().toString(36).substring(2), p = E(g, "modelValue"), F = parseInt(p.value.split("-")[1], 10), Y = parseInt(p.value.split("-")[2], 10), $ = parseInt(p.value.split("-")[0], 10), n = f(d(F) ? "" : F), l = f(d(Y) ? "" : Y), r = f(d($) ? "" : $), v = f(!1), I = f(!1), N = T(), b = m(() => {
      if (!y.minAge || !r.value || !n.value || !l.value || String(r.value).length < 4) return !1;
      const t = /* @__PURE__ */ new Date(), e = new Date(r.value, n.value - 1, l.value);
      let a = t.getFullYear() - e.getFullYear();
      const u = t.getMonth() - e.getMonth();
      return (u < 0 || u === 0 && t.getDate() < e.getDate()) && a--, a < y.minAge;
    }), B = m(() => {
      if (d(n.value) || d(l.value) || d(r.value) || String(r.value).length < 4) return !1;
      const t = parseInt(n.value, 10), e = parseInt(l.value, 10), a = parseInt(r.value, 10), u = new Date(a, t - 1, e);
      return u.getFullYear() === a && u.getMonth() === t - 1 && u.getDate() === e;
    });
    function s() {
      v.value = !1;
      const [t, e, a] = K(
        l.value,
        n.value,
        r.value
      );
      p.value = `${a}-${e}-${t}`, l.value = t, n.value = e;
    }
    function k(t) {
      t.currentTarget.contains(t.relatedTarget) || (I.value = !0);
    }
    function S(t) {
      if (!isNaN(parseInt(t.key, 10)) && t.target.value.length >= t.target.maxLength) {
        const e = t.target.nextElementSibling;
        e && e.focus();
      }
    }
    const V = m(() => B.value ? !1 : y.invalid ? !0 : I.value && N.required !== void 0), i = m(() => b.value || V.value);
    C({
      get isUnderAge() {
        return b.value;
      },
      get isComplete() {
        return B.value;
      }
    });
    const w = U("container");
    return q(() => {
      s(), O(w.value);
    }), (t, e) => (h(), D("div", {
      ref: "container",
      class: z([
        "offset-date-of-birth",
        t.$attrs.required ? "required" : "",
        v.value ? "focused" : "",
        i.value ? "invalid" : ""
      ])
    }, [
      c("div", {
        class: "offset-date-of-birth-inputs",
        role: "group",
        "aria-labelledby": `${o}-label`,
        onFocusout: k
      }, [
        c("label", {
          id: `${o}-label`
        }, "Date of Birth", 8, j),
        x(c("input", {
          type: "text",
          placeholder: "MM",
          maxlength: "2",
          "aria-label": "Birth month",
          "aria-invalid": i.value,
          "aria-describedby": i.value ? `${o}-error` : void 0,
          "onUpdate:modelValue": e[0] || (e[0] = (a) => n.value = a),
          onKeyup: S,
          onFocusin: e[1] || (e[1] = (a) => v.value = !0),
          onFocusout: s,
          onChange: s
        }, null, 40, H), [
          [M, n.value]
        ]),
        e[6] || (e[6] = A("/ ", -1)),
        x(c("input", {
          type: "text",
          placeholder: "DD",
          maxlength: "2",
          "aria-label": "Birth day",
          "aria-invalid": i.value,
          "aria-describedby": i.value ? `${o}-error` : void 0,
          "onUpdate:modelValue": e[2] || (e[2] = (a) => l.value = a),
          onKeyup: S,
          onFocusin: e[3] || (e[3] = (a) => v.value = !0),
          onFocusout: s,
          onChange: s
        }, null, 40, J), [
          [M, l.value]
        ]),
        e[7] || (e[7] = A("/ ", -1)),
        x(c("input", {
          type: "text",
          placeholder: "YYYY",
          maxlength: "4",
          "aria-label": "Birth year",
          "aria-invalid": i.value,
          "aria-describedby": i.value ? `${o}-error` : void 0,
          "onUpdate:modelValue": e[4] || (e[4] = (a) => r.value = a),
          onFocusin: e[5] || (e[5] = (a) => v.value = !0),
          onFocusout: s,
          onChange: s
        }, null, 40, Q), [
          [M, r.value]
        ])
      ], 40, P),
      b.value ? (h(), D("div", {
        key: 0,
        id: `${o}-error`,
        class: "error",
        role: "alert"
      }, " You must be at least " + R(g.minAge) + " years old. ", 9, W)) : V.value ? (h(), D("div", {
        key: 1,
        id: `${o}-error`,
        class: "error",
        role: "alert"
      }, " Please enter a valid date of birth. ", 8, X)) : _("", !0)
    ], 2));
  }
}, re = /* @__PURE__ */ L(Z, [["__scopeId", "data-v-47c7c5fe"]]);
export {
  re as D
};
